import { Component, Inject } from '@angular/core';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISelection } from 'pbc.types';

import { BereichsQueryFilterConfig, IBereichsQueryShapes } from 'fa-kt.types';
import { BereichsService } from '../service';

@Component({
  selector: 'fa-kt-bereichs-filter',
  templateUrl: './bereichs-filter.component.html',
  styleUrls: ['./bereichs-filter.component.css'],
})
export class BereichsFilterComponent {
  readonly subscriptions: Subscription[] = [];

  BereichsFilterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public bereichs: BereichsService,
  ) {
    this.BereichsFilterConfig = BereichsQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.bereichs.shapes$.subscribe((shapes: IBereichsQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.BereichsFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.BereichsFilterConfig[index].selections = shapes;
  }
}
